import React, { useEffect, useState } from "react";
import "../css/ConfirmSalesOrderPopup.css";
import axios from "axios";
import LoadingUI from "./LoadingUI";

function ConfirmSalesOrderPopup(props) {


    const [loadingScreenState, setLoadingScreenState] = useState(false);
    const { changeStatusOfClickedOnContinueButton, showHideSalesOrderPopup, clearCurrentFormFromLocalStorage } = props;
    const { salesOrderObjectToSend } = props;

    console.log("salesOrderObjectToSend is", salesOrderObjectToSend);

    let totalOfAllItems = salesOrderObjectToSend.order_items_array.reduce((previousValue, currentValue) => {
        return previousValue + (currentValue.item_qty * currentValue.item_price);
    }, 0);

    let salesManName = localStorage.getItem("cubix_order_taking_sales_man");

    const toFixedNumber = (number) => {
        const spitedValues = String(number.toLocaleString()).split('.');
        let decimalValue = spitedValues.length > 1 ? spitedValues[1] : '';
        decimalValue = decimalValue.concat('00').substr(0, 2);

        return spitedValues[0] + '.' + decimalValue;
    }

    const sendSalesOrderToApi = () => {

        setLoadingScreenState(true);
        console.log("sending data is ", salesOrderObjectToSend);

        // creating new array in the format of backend requirement

        console.log("total ", totalOfAllItems);

        let updatedArrayToSend = salesOrderObjectToSend.order_items_array.map((item) => {
            return ({
                Cust_Acc: salesOrderObjectToSend.company_account_number,
                Acc_Descr: salesOrderObjectToSend.company_name,
                Total_Amt: parseFloat(totalOfAllItems).toFixed(2),
                Slno: item.id,
                code: item.item_code,
                description: item.item_name,
                locn: "",
                unit: item.item_unit,
                qty: item.item_qty,
                unit_price: Math.floor(item.item_price) == item.item_price ? parseFloat(item.item_price).toFixed(2) : toFixedNumber(item.item_price),
                disc_percentage: 0,
                Amount: Math.floor(item.item_qty * item.item_price) == item.item_qty * item.item_price ? parseFloat(item.item_qty * item.item_price).toFixed(2) : toFixedNumber(item.item_qty * item.item_price) ,
                x: "",
                cntrl: "",
                fraction: 1,
                qno: 0,
                oem: "",
                vat_percentage: 0,
                Vatamt: 0,
                total: 0,
                UPrice_VInc: 0,
                Curstk: 0,
                sales_man: salesManName,
                itemwiseRemark: item.itemwiseRemark,
                BarcodeRemark: item.BarcodeRemark,
                OrderRemark: salesOrderObjectToSend.OrderRemark
            })
        })

        console.log("updatedArrayToSend ", updatedArrayToSend);

        axios.post(`${process.env.REACT_APP_BASE_URL}/Sales_Order`, updatedArrayToSend).then((res) => {
            console.log("res is ", res);
            setLoadingScreenState(false);
            if (res.data.result == "Saved") {
                //close popup then clear data from local storage

                clearCurrentFormFromLocalStorage();

                showHideSalesOrderPopup("order_send");

            }
        }).catch(err => {
            setLoadingScreenState(false);
            console.log("error is ", err)
        });
    }


    return (
        <div className="ConfirmSalesOrderPopup-root-container">

            <div className="card ConfirmSalesOrderPopup-card">
                <h4>Sales Order</h4>
                <div className="ConfirmSalesOrderPopup-underline"></div>

                <div className="mt-4 small-label"><small>Customer</small></div>
                <div>
                    <label className="font-weight-600">{salesOrderObjectToSend.company_name}</label>
                </div>
                <div>
                    <label className="font-weight-600">{salesOrderObjectToSend.company_address_1},{salesOrderObjectToSend.company_address_2},{salesOrderObjectToSend.company_address_3}</label>
                </div>
                <div>
                    <label className="font-weight-600">{salesOrderObjectToSend.company_phone}</label>
                </div>

                <div className="mt-4 small-label"><small>Order Remarks</small></div>
                <div>
                    <label className="font-weight-600">{salesOrderObjectToSend.OrderRemark}</label>
                </div>

                <small className="mt-4 small-label">Item List</small>


                <div className="ConfirmSalesOrderPopup-list-container">
                    {salesOrderObjectToSend.order_items_array.map((item, index) => {
                        return (
                            <div className="ConfirmSalesOrderPopup-sales-order-list-item" key={index}>
                                <div className="ConfirmSalesOrderPopup-sales-order-list-item-first-panel">

                                    {/* left portion */}
                                    <div className="left-child pe-3">
                                        <div className="child-1 me-2">
                                            <label>{item.id}</label>
                                        </div>
                                        <div className="ConfirmSalesOrderPopup-item-name-qty-container child-2">
                                            <label>{item.item_name}</label>
                                            <div className="ConfirmSalesOrderPopup-unit-price-quantity-short-details">
                                                <small>Item Code : </small>
                                                <label>{item.item_code}</label>
                                            </div>
                                            <div className="ConfirmSalesOrderPopup-unit-price-quantity-short-details">
                                                <small>Unit Price : </small>
                                                <label>{item.item_price}</label>
                                            </div>
                                            <div className="ConfirmSalesOrderPopup-unit-price-quantity-short-details">
                                                <small>Quantity : </small>
                                                <label>{item.item_qty}</label>
                                            </div>
                                            <div className="ConfirmSalesOrderPopup-unit-price-quantity-short-details">
                                                <small>Item Remark : </small>
                                                <label>{item.itemwiseRemark}</label>
                                            </div>
                                            <div className="ConfirmSalesOrderPopup-unit-price-quantity-short-details">
                                                <small>Item Barcode : </small>
                                                <label>{item.BarcodeRemark}</label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* right portion */}
                                    <div className="right-child child-3">
                                        <label>{parseFloat((item.item_qty * item.item_price).toFixed(2))}</label>
                                    </div>

                                </div>
                            </div>
                        )
                    })
                    }
                </div>
                {/* list container ends */}

                <div className="mt-2">
                    <div className="ConfirmSalesOrderPopup-subotal-container"><label>Subtotal</label><label>{parseFloat((totalOfAllItems).toFixed(2))}</label></div>
                </div>

                <div className="ConfirmSalesOrderPopup-tax-total-container">
                    <div><label>VAT % : </label><label>5%</label></div>
                    <div><label>VAT : </label><label>{parseFloat(((totalOfAllItems * 5) / 100).toFixed(2))}</label></div>
                    <div><label>Amount Incl.VAT</label>{parseFloat((totalOfAllItems + (totalOfAllItems * 5) / 100).toFixed(2))}</div>
                </div>

                <div className="ConfirmSalesOrderPopup-bottom-panel mt-4">
                    <button className="ConfirmSalesOrderPopup-bottom-panel-cancel-button" onClick={changeStatusOfClickedOnContinueButton}>Cancel</button>
                    <button className="ConfirmSalesOrderPopup-bottom-panel-cancel-send-order" onClick={sendSalesOrderToApi}>Send Order</button>
                </div>

            </div>

            {loadingScreenState &&
                <div className="LoginPage-Loading-Layout">
                    <div className="LoginPage-Loading-Layout-child card">
                        <LoadingUI />
                    </div>
                </div>
            }
        </div>
    )
}

export default ConfirmSalesOrderPopup;